import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <p className="num text-[48px] font-semibold text-line">404</p>
      <p className="text-ink-2">{t("common.notFound")}</p>
      <Link to="/" className="btn-primary">{t("nav.home")}</Link>
    </div>
  );
}
